class FreeSamplesPanel extends HTMLElement {
  connectedCallback() {
    this._saveTimer = null;

    // Checkboxes and radio buttons: save immediately (0 ms — next tick after
    // the browser has updated the checked state).
    this.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => this._scheduleSave(0));
    });

    // Textarea: debounce 500 ms so we don't fire on every keystroke.
    this.querySelectorAll('textarea').forEach((ta) => {
      ta.addEventListener('input', () => this._scheduleSave(500));
    });
  }

  _scheduleSave(delay) {
    clearTimeout(this._saveTimer);
    this._saveTimer = setTimeout(() => this.save(), delay);
  }

  async save() {
    try {
      const attributes = {};

      // Checkboxes — checked → 'si', unchecked → '' (clears the cart attribute)
      for (const cb of this.querySelectorAll('input[type="checkbox"]')) {
        const key = cb.name.match(/\[(.+)\]/)?.[1];
        if (key) attributes[key] = cb.checked ? 'si' : '';
      }

      // Radio groups — selected value or '' to clear
      const radioNames = new Set(
        [...this.querySelectorAll('input[type="radio"]')].map((r) => r.name)
      );
      for (const name of radioNames) {
        const key = name.match(/\[(.+)\]/)?.[1];
        if (!key) continue;
        const checked = this.querySelector(`input[type="radio"][name="${CSS.escape(name)}"]:checked`);
        attributes[key] = checked ? checked.value : '';
      }

      // Textarea
      for (const ta of this.querySelectorAll('textarea')) {
        const key = ta.name.match(/\[(.+)\]/)?.[1];
        if (key) attributes[key] = ta.value.trim();
      }

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!res.ok) {
        console.error('[FreeSamples] update failed:', await res.json());
      }
    } catch (err) {
      console.error('[FreeSamples] save failed:', err);
    }
  }
}

if (!customElements.get('free-samples-panel')) {
  customElements.define('free-samples-panel', FreeSamplesPanel);
}
